import actions from "@/store/desktop/actions";
import mutations from "@/store/desktop/mutations";
import state from "@/store/desktop/state";

export default {
  actions,
  mutations,
  state,
};
